import React, { useEffect, useState } from 'react';
import { HeroUnit } from '../../../components/HeroUnit/HeroUnit';
import { SearchBar } from '../../../components/SearchBar/SearchBar';
import { Box, CircularProgress, Container, Grid, makeStyles } from '@material-ui/core';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'qs';
import { AppPricePlanDetailsType, usePublicAppListingsQuery } from '../../../types/generated';
import { AppCard } from '../../../components/AppCard/AppCard';

const css = makeStyles(theme => ({
    searchResults: {
        padding: theme.spacing(8, 0),
    },
}));

export const AppListings = (): JSX.Element => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = qs.parse(location.search, { ignoreQueryPrefix: true });
    const cq: string = params.q ? params.q.toString() : '';
    const [query, setQuery] = useState(cq);
    const classes = css();

    const { loading: appsLoading, data: appsData } = usePublicAppListingsQuery({
        variables: {
            filter: {
                searchTerm: query,
            },
            first: 50,
        },
    });

    useEffect(() => {
        if (query.length <= 0) {
            navigate('/apps');
        } else if (query !== cq) {
            navigate('/apps?q=' + query);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, query]);

    return (
        <>
            <HeroUnit
                title={'Apps'}
                subTitle={'Find the right tools for your business.'}
                smaller={true}
            >
                <SearchBar
                    placeholder={'Filter results'}
                    value={query}
                    onChange={value => setQuery(value)}
                    onSearch={value => setQuery(value)}
                />
            </HeroUnit>
            <div className={classes.searchResults}>
                <Container maxWidth="lg">
                    {appsLoading ? (
                        <CircularProgress />
                    ) : (
                        <Grid container spacing={4}>
                            {appsData && appsData?.publicAppListings?.totalCount !== 0 ? (
                                appsData?.publicAppListings.edges.map(({ node: appListing }) => (
                                    <Grid item key={appListing.id} xs={12} sm={6} md={4} lg={3}>
                                        <AppCard
                                            id={appListing.id}
                                            title={appListing.name}
                                            tagLine={appListing.tagLine}
                                            imageUrl={appListing.icon.sourceUrl}
                                            priceType={appListing.chargeType}
                                            pricePlans={
                                                appListing.pricePlans as AppPricePlanDetailsType[]
                                            }
                                            freeTrialDays={appListing.freeTrialDays}
                                            oneTimeChargeAmount={appListing.oneTimeChargeAmount}
                                        />
                                    </Grid>
                                ))
                            ) : (
                                <Container>
                                    <Box
                                        p={4}
                                        py={6}
                                        display={'flex'}
                                        flexDirection={'column'}
                                        justifyContent={'center'}
                                    >
                                        <Box
                                            mb={2}
                                            fontWeight={500}
                                            fontSize={'28px'}
                                            color={'secondary.main'}
                                        >
                                            Nothing here
                                        </Box>
                                        <Box
                                            fontWeight={300}
                                            fontSize={'20px'}
                                            color={'secondary.main'}
                                        >
                                            No apps found for current condition
                                        </Box>
                                    </Box>
                                </Container>
                            )}
                        </Grid>
                    )}
                </Container>
            </div>
        </>
    );
};
